<!--begin::hero-->
<section
    class="position-relative d-flex align-items-center bg-light mb-0 py-lg-5 pt-5 bg-size-cover bg-position-center bg-repeat-0"
    style="background-image: url('assets/media/img/OpenData.png');height: 300px">
    <span class="position-absolute top-0 start-0 w-100 h-100 bg-primary opacity-50"></span>
    <div class="container position-relative zindex-5">
        <div class="row justify-content-center">
            <div
                class="col-12 order-md-1 order-2 d-flex flex-column justify-content-between pt-2 align-items-center text-center">
                <!-- Text -->
                <h1 class="text-white h1 fw-semibold m-0 position-relative zindex-5" [innerText]="PageTitle">
                </h1>
            </div>
        </div>
    </div>
</section>
<!--begin::breadcrumb-->
<section class="mb-5 bg-infoLight breadcrumb-containter">
    <div class="container">
        <div class="row">
            <div class="col m-3">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="{{_lang}}/home" [innerText]="home"
                                class="fs-sm fw-normal"></a></li>
                        <li class="breadcrumb-item fw-normal " aria-current="page">
                            <a href="{{_lang}}/opendataall">{{PageTitle}}</a>
                        </li>
                        <li class="breadcrumb-item fw-normal active" aria-current="page"> {{ categoryname}}</li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</section>
<!--begin::open-data-->
<div class="container">
    <div class="row justify-content-md-start justify-content-center mb-4">
        <div
            class="col-sm-12 order-md-1 order-2 d-flex flex-column justify-content-between pt-2 align-items-md-start align-items-center text-md-start text-center">
            <h1 class="text-primary h4 mb-2">
                {{ categoryname}}
            </h1>
            <span class="bg-warning mt-1 mb-2" style="height: 0.35rem;width: 3.5rem;"></span>

            <div *ngFor="let item of data ">
                <p class="text-primary mb-2" [innerHTML]="item.ItemFields?.Description"></p>
            </div>
        </div>
    </div>
    <!-- search bar -->
    <div class="row justify-content-center">
        <div class="col-12 mb-5">
            <div class="input-group position-relative">
                <input type="text" class="form-control form-control-lg ps-5" placeholder="{{reportsearch}}     .."
                    [(ngModel)]="searchText">
                <i
                    class="bx bx-search fs-6 text-secondary position-absolute top-50 start-0 translate-middle-y ms-3 zindex-5"></i>
            </div>
        </div>
    </div>
    <!-- filter -->
    <!-- <div class="col-12 my-1">
        <h5 class="fs-lg text-primary fw-semibold mb-2 d-none">{{Category}}</h5>
        <div class="d-flex flex-row flex-wrap justify-content-start w-100" *ngIf="tags.length > 0">
            <div class="me-2 mb-2 nav nav-tabs-alt products-checkbox">
                <input type="checkbox" class="btn-check products-category" name="options2"
                    id="option-all-tags" autocomplete="off" [(ngModel)]="tagsAll"
                    (ngModelChange)="changeTage()">
                <label class="nav-link fs-sm" for="option-all-tags">{{all}}</label>
            </div>
            <div class="me-2 mb-2 nav nav-tabs-alt products-checkbox"
                *ngFor="let element of researchCategory; let i = index">
                <input type="checkbox" class="btn-check products-category" name="options2"
                    id="chbox{{i}}" autocomplete="off" [(ngModel)]="tagsStatus[i]"
                    (ngModelChange)="filterChange()">
                <label class="nav-link fs-sm" for="chbox{{i}}">{{element.ItemFields?.ItemCategory?.LookupValue?.trim()}}</label>
            </div>
        </div>
    </div> -->
    <!-- // -->
    <!-- <ul *ngFor="let m of researchCategory">
            <li>{{m.ItemFields?.ItemCategory?.LookupValue?m.ItemFields?.ItemCategory?.LookupValue: 'الكل' }}</li>
    </ul> -->
    <!-- Data -->
    <div class="row row-cols-xxl-2 row-cols-1 g-4">
        <div class="col-12" *ngFor="let element of reasearchListResponse | filter:searchText;  let i = index">
            <div class="card h-100 border-1 bg-white shadow-sm overflow-hidden mb-3 p-3">
                <div class="row g-0">
                    <!-- img -->
                    <div *ngIf="element.ItemFields?.ImageThumbnails?.Url"
                        class="col-xxl-4 col-lg-3 col-md-12 col-12 position-relative bg-position-center bg-repeat-0 bg-size-cover rounded-3 d-block mb-2 mb-lg-0 bg-primary"
                        style="min-height: 12rem;background-size: 150px !important;"
                        [ngStyle]="{'background-image': 'url(' +'\'' +element.ItemFields?.ImageThumbnails?.Url?.replace(imptempPublicUrl,imgPublicUrl) +'\'' +')'}">
                    </div>
                    <div *ngIf="!element.ItemFields?.ImageThumbnails?.Url"
                        class="col-xxl-4 col-lg-3 col-md-12 col-12 position-relative bg-position-center bg-repeat-0 bg-size-cover rounded-3 d-block mb-2 mb-lg-0"
                        style="min-height: 12rem;background-size: 150px !important;"
                        [ngStyle]="{'background-image': 'url(assets/img/data/data.png)'}">
                        <!-- <i
                            class="bx bx-image bx-flip-horizontal text-white display-3 d-flex h-100 justify-content-center align-items-center"></i> -->
                    </div>


                    <!-- content -->
                    <div class="col-xxl-8 col-lg-9 col-md-12 col-12">
                        <div class="px-0 px-lg-4 py-0 d-flex flex-column justify-content-center h-100">
                            <p class="text-primary" [innerHTML]="element.ItemFields.ODTitle"></p>
                            <div class="d-flex flex-column flex-lg-row justify-content-between text-primary mt-3">
                                <div class="d-flex flex-column flex-lg-row">
                                    <a class="btn btn-outline-primary px-2 py-1 me-0 me-lg-3 mb-lg-0 mb-2 d-flex justify-content-between"
                                        target="_blank"
                                        *ngIf="element.ItemFields?.IsRequiredPersonalInformation &&  element.ItemFields?.FileLink?.Url"
                                        href="personalinfo/{{element.ItemFields.GUID}}/opendata">
                                        <span class="d-inline "> {{reportdownload}}</span>

                                    </a>
                                    <a class="btn btn-outline-primary px-2 py-1 me-0 me-lg-3 mb-lg-0 mb-2 d-flex justify-content-between"
                                        target="_blank"
                                        *ngIf="element.ItemFields?.IsRequiredPersonalInformation &&  element.ItemFields?.FileLinkJSON?.Url"
                                        href="personalinfo/{{element.ItemFields.GUID}}/opendata">
                                        <span class="d-inline ">json </span>

                                    </a>
                                    <a class="btn btn-outline-primary px-2 py-1 me-0 me-lg-3 mb-lg-0 mb-2 d-flex justify-content-between"
                                        target="_blank"
                                        *ngIf="element.ItemFields?.IsRequiredPersonalInformation &&  element.ItemFields?.FileLinkCSV?.Url"
                                        href="personalinfo/{{element.ItemFields.GUID}}/opendata">
                                        <span class="d-inline ">SAV</span>
                                    </a>
                                    <a class="btn btn-outline-primary px-2 py-1 me-0 me-lg-3 mb-lg-0 mb-2 d-flex justify-content-between"
                                        target="_blank"
                                        *ngIf="element.ItemFields?.IsRequiredPersonalInformation &&  element.ItemFields?.FileLinkExcel?.Url"
                                        href="personalinfo/{{element.ItemFields.GUID}}/opendata">
                                        <span class="d-inline">excel</span>

                                    </a>
                                    <a class="btn btn-outline-primary px-2 py-1 me-0 me-lg-3 mb-lg-0 mb-2 d-flex justify-content-between"
                                        target="_blank"
                                        *ngIf="element.ItemFields?.IsRequiredPersonalInformation &&  element.ItemFields?.FileLinkSPSS?.Url"
                                        href="personalinfo/{{element.ItemFields.GUID}}/opendata">
                                        <span class="d-inline">spss</span>

                                    </a>

                                    <a class="btn btn-primary fs-sm border-2 me-lg-2 mb-lg-0 mb-2" target="_blank"
                                        (click)="putVisitNo(element.ItemId)"
                                        href="{{element.ItemFields?.FileLink?.Url ?.replace(imptempPublicUrl,imgPublicUrl)}}"
                                        *ngIf="!element.ItemFields?.IsRequiredPersonalInformation &&  element.ItemFields?.FileLink?.Url">
                                        عرض
                                    </a>
                                    <a class="btn btn-primary fs-sm border-2 me-lg-2 mb-lg-0 mb-2" target="_blank"
                                        (click)="putVisitNo(element.ItemId)"
                                        href="{{element.ItemFields?.FileLinkJSON?.Url ?.replace(imptempPublicUrl,imgPublicUrl)}}"
                                        *ngIf="!element.ItemFields?.IsRequiredPersonalInformation && element.ItemFields?.FileLinkJSON?.Url">
                                        JSON
                                    </a>
                                    <a class="btn btn-primary fs-sm border-2  me-lg-2 mb-lg-0 mb-2" target="_blank"
                                        (click)="putVisitNo(element.ItemId)"
                                        href="{{element.ItemFields?.FileLinkCSV?.Url ?.replace(imptempPublicUrl,imgPublicUrl)}}"
                                        *ngIf="!element.ItemFields?.IsRequiredPersonalInformation && element.ItemFields?.FileLinkCSV?.Url">
                                        SAV
                                    </a>
                                    <a class="btn btn-primary fs-sm border-2  me-lg-2 mb-lg-0 mb-2" target="_blank"
                                        (click)="putVisitNo(element.ItemId)"
                                        href="{{element.ItemFields?.FileLinkExcel?.Url ?.replace(imptempPublicUrl,imgPublicUrl)}}"
                                        *ngIf="!element.ItemFields?.IsRequiredPersonalInformation && element.ItemFields?.FileLinkExcel?.Url">
                                        Excel
                                    </a>
                                    <a class="btn btn-primary fs-sm border-2  me-lg-2 mb-lg-0 mb-2" target="_blank"
                                        (click)="putVisitNo(element.ItemId)"
                                        href="{{element.ItemFields?.FileLinkSPSS?.Url ?.replace(imptempPublicUrl,imgPublicUrl)}}"
                                        *ngIf="!element.ItemFields?.IsRequiredPersonalInformation && element.ItemFields?.FileLinkSPSS?.Url">
                                        SPSS
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="d-flex flex-lg-row flex-column bg-light p-2 rounded-5">
                            <div class="d-flex align-items-center justify-content-lg-center h-100 w-100" *ngIf="element.ItemFields?.PublishDate">
                                    <i class="bx bx-calendar fs-lg me-1 text-primary"></i>
                                    <span class="fs-sm me-1 text-primary">{{PublishDate}}</span>
                                    <span class="fs-sm text-primary"
                                        [innerHTML]="element.ItemFields?.PublishDate| date: 'yyyy/MM/dd'"></span>
                            </div>
                            <div class="d-flex align-items-center justify-content-lg-center h-100  w-100"
                                *ngIf="element.ItemFields?.VisitingCount">
                                <i class="bx bx-download fs-lg me-1 text-primary"></i>
                                <span class="fs-sm me-1 text-primary">{{downloadCount}}</span>
                                <span class="fs-sm text-primary" [innerHTML]="element.ItemFields?.VisitingCount"></span>
                            </div>
                            <div *ngIf="element.ItemFields?.Publisher"
                                class="d-flex align-items-center justify-content-lg-center h-100 w-100">
                                    <i class="bx bx-user fs-lg me-1 text-primary"></i>
                                    <span class="fs-sm text-primary" [innerHTML]="element?.ItemFields?.Publisher "> </span>
                            </div>
                        </div>

                    </div>

                    <!-- <div class="offset-xxl-4 offset-lg-3 col-xxl-8 col-lg-9 col-12">
                        <div class="d-flex align-items-center h-100 ps-4" *ngIf="element.ItemFields?.PublishDate">
                            <div class="mb-0" *ngIf="element.ItemFields?.PublishDate">
                                <i class="bx bx-calendar fs-lg me-1"></i>
                                <span class="fs-sm"
                                    [innerHTML]="element.ItemFields?.PublishDate| date: 'yyyy/MM/dd'"></span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center h-100 ps-4"  *ngIf="element.ItemFields?.VisitingCount">
                                <i class="bx bx-download fs-lg me-1 text-primary"></i>
                                <span class="fs-sm me-1 text-primary">{{downloadCount}}</span>
                                <span class="fs-sm text-primary"
                                    [innerHTML]="element.ItemFields?.VisitingCount"></span>
                        </div>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
    <!--begin::share-->
    <app-shareicons></app-shareicons>


    <!-- <div>{{downloadCount}}</div>
    <div>{{PublishDate}}</div> -->
</div>